import { moveProject } from '@/backend/moveProject'
import { useWorkspaceContext } from '../Workspaces/useWorkspaceContext'
import { serializeProject, useProjects } from './useProjects'

type MoveProjectParams = {
  projectId: string
  parentFolderId: string | null
}

/**
 * Provides a function that is used to move a project from one folder to another, performing
 * optimistic store updates and reverting back if the backend request fails.
 */
export const useMoveProject = () => {
  const projectsStore = useProjects()

  const { workspaceId } = useWorkspaceContext()
  return async ({ parentFolderId, projectId }: MoveProjectParams) => {
    const oldProject = projectsStore.getProjectById(projectId)

    if (oldProject) {
      // We should always be inside this block, but it doesn't prevent us
      // sending the request to the backend if it's not, so this optimistic
      // update doesn't need to happen.
      projectsStore.updateProject(projectId, {
        ...oldProject,
        parentFolderId,
      })
    }

    const res = await moveProject({
      parentFolderId,
      projectId,
      workspaceId: workspaceId.value,
    })

    if (res.ok) {
      projectsStore.updateProject(projectId, serializeProject(res.data))
    } else {
      projectsStore.updateProject(projectId, {
        ...oldProject,
        parentFolderId: oldProject?.parentFolderId,
      })
    }

    return res
  }
}
